<template>
  <div class="login-wrapper">
    <router-link to="/" class="login-header flex-row flex-spbt">
      <img class="logo" src="../assets/img/saai-logo.png" alt="logo" />
      <div>SAAI & PEER</div>
    </router-link>

    <div class="component-center">
      <p :style="isUnavailable" class="login-warning">
        {{ noticeText }}
      </p>
      <Login v-if="mode" @controlMode="controlMode" @showNotice="showNotice" />
      <Enrollment v-else @controlMode="controlMode" @showNotice="showNotice" />
    </div>
  </div>
</template>

<script>
import Login from '@/components/User/Login.vue';
import Enrollment from '@/components/User/Enrollment.vue';

export default {
  name: 'User',
  data() {
    return {
      mode: 1,
      isShowWarningText: false,
      noticeText: '',
      timer: null,
    };
  },
  components: {
    Login,
    Enrollment,
  },
  methods: {
    controlMode() {
      this.mode = !this.mode;
    },
    showNotice(text) {
      this.isShowWarningText = true;
      this.noticeText = text;

      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.isShowWarningText = false;
      }, 3000);
    },
  },
  computed: {
    isUnavailable() {
      return this.isShowWarningText
        ? {
            visibility: 'visible',
          }
        : {
            visibility: 'hidden',
          };
    },
  },
};
</script>

<style lang="scss">
.login-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: auto;
  font-size: 1rem;
}

.login-warning {
  position: absolute;
  top: -40px;
  width: 100%;
  padding: 5px 0;
  border-radius: 5px;
  background: rgb(255, 42, 71);
  color: white;
  text-align: center;
  margin-bottom: 10px;
  font-size: 0.9rem;
}

.login-header {
  position: absolute;
  top: 20px;
  left: 70px;
  font-size: 28px;
  color: #243f76;
}

.login-wrap {
  width: 550px;
  border: 2px solid #243f76;
  border-radius: 10px;
  padding: 20px 40px;
  box-shadow: 0px 0px 15px 0px #d8d8d8;
}
.login-logo {
  font-size: 1.7rem;
  font-weight: bold;
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
}
.login-form {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.1em;
  margin: auto;
  margin-bottom: 10px;

  input {
    width: 77%;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 1rem;

    &:focus {
      outline: 2px solid #5b6dbc !important;
    }
  }
}
.login-button {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  width: 100%;
  margin-top: 30px;
}
.login-blue:active,
.login-lightblue:active {
  opacity: 0.8;
}
.login-button * {
  width: 100%;
  padding: 5px 0;
  margin-bottom: 10px;
  border: 0;
  border-radius: 5px;
  color: white;
}
.login-blue {
  background: #243f76;
}
.login-lightblue {
  background: #5b6dbc;
}
</style>
